import { render } from "./Sidebar2.vue?vue&type=template&id=d3cedd8a&scoped=true"
import script from "./Sidebar2.vue?vue&type=script&lang=js"
export * from "./Sidebar2.vue?vue&type=script&lang=js"

import "./Sidebar2.vue?vue&type=style&index=0&id=d3cedd8a&scoped=true&lang=scss"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3cedd8a"]])

export default __exports__